export enum ReportTypeEnum {
  Offers = 'offers',
  Installers = 'installers',
}
